import { normalizeLocale } from "../translate.js";
import { infoPagesEn } from "./en.js";
import { infoPagesNl } from "./nl.js";

/** @type {Record<string, import("./types.js").InfoPagesCatalog>} */
const INFO_PAGES_BY_LOCALE = {
  nl: infoPagesNl,
  en: infoPagesEn,
};

/** @type {string[]} */
export const COLOFON_PAGE_IDS = ["about", "faq", "feedback", "privacy", "disclaimer"];

/**
 * @param {string} [locale]
 * @returns {import("./types.js").InfoPagesCatalog}
 */
export function buildInfoPages(locale) {
  const normalized = normalizeLocale(locale);
  return INFO_PAGES_BY_LOCALE[normalized] ?? infoPagesNl;
}

/**
 * @param {import("./types.js").InfoPagesCatalog} infoPages
 * @param {string[]} ids
 * @returns {{ question: string, answer: string }[]}
 */
export function pickFaqItems(infoPages, ids) {
  const byId = Object.fromEntries(infoPages.faq.items.map((item) => [item.id, item]));
  return ids.map((id) => byId[id]).filter(Boolean);
}

/**
 * @param {import("./types.js").InfoPagesCatalog} infoPages
 * @param {string} pageId
 * @returns {import("./types.js").InfoPagesCatalog[keyof import("./types.js").InfoPagesCatalog] | null}
 */
export function getInfoPage(infoPages, pageId) {
  return infoPages[pageId] ?? null;
}
